import moment from "moment";
import { DOWNLOAD_AMOUNT_CHANGED, CUSTOM_DATE_RANGE_CHANGED } from "./types";

export const downloadAmountChanged = (e,label) => dispatch => {
  dispatch({
    type: DOWNLOAD_AMOUNT_CHANGED,
    payload: e.target.value,
    label
  });
};

export const customDateRangeChanged = (date, dateType) => dispatch => {  
  const payload = { [dateType]: new Date(date) };
  dispatch({
    type: CUSTOM_DATE_RANGE_CHANGED,
    dateType,
    payload
  });
};

export const getPreviousDate = (endDate, numberOfDays) => {
  return moment(endDate)
    .subtract(numberOfDays ? numberOfDays : 30, "days")
    .format();
};
